module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"error.under_construction":"อยู่ระหว่างการพัฒนา"}}')
  delete Component.options._Ctor
}
